import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.657 2.343A7.979 7.979 0 0 0 8 0a7.98 7.98 0 0 0-5.657 2.343A7.98 7.98 0 0 0 0 8a7.98 7.98 0 0 0 2.343 5.657A7.98 7.98 0 0 0 8 16a7.978 7.978 0 0 0 5.657-2.343A7.98 7.98 0 0 0 16 8a7.978 7.978 0 0 0-2.343-5.657Zm-1.173 1.173A6.316 6.316 0 0 1 14.34 8a6.317 6.317 0 0 1-1.857 4.484A6.318 6.318 0 0 1 8 14.34a6.316 6.316 0 0 1-4.484-1.857A6.317 6.317 0 0 1 1.66 8c0-1.754.709-3.334 1.857-4.484A6.317 6.317 0 0 1 8 1.66c1.753 0 3.333.709 4.484 1.857Z",
  fill: "#E9794D"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "7",
  y: "4",
  width: "2",
  height: "5",
  rx: "1",
  fill: "#E9794D"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "7",
  y: "10",
  width: "2",
  height: "2",
  rx: "1",
  fill: "#E9794D"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render };